"use client";

import { useSelection } from "@trydig/centra/client";
import { useEffect } from "react";

/**
 * Same idea as `app/[geo]/checkout/(pre)/_InjectCentraCheckoutScript.tsx`,
 * but reading `useSelection()` from inside `GiftCardProvider` — which swaps
 * the Centra context to the gift selection — so this injects the checkout
 * script for the *gift* selection rather than the shopping cart.
 */
export const InjectGiftCheckoutScript = () => {
	const { data } = useSelection({});
	const script = data?.selection?.centraCheckoutScript;

	useEffect(() => {
		if (!script) return;

		const el = document.createElement("script");
		el.innerHTML = script;

		document.body.appendChild(el);

		return () => {
			el.remove();
		};
	}, [script]);

	return null;
};
